import React from 'react'

const SVG = ({
  style = {},
  fill = ['#FFC74A', '#FFFFFF'],
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 33 31'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`svg-icon ${className || ''}`}
  >
    <g>
      <path
        fill={fill[0]}
        d='M0,27c0-0.7,0.2-1.4,0.5-1.9L13.2,2c1-1.9,3.4-2.6,5.2-1.5C19,0.8,19.5,1.4,19.9,2l12.6,23
		c0.3,0.6,0.5,1.3,0.5,2c0.1,2.1-1.5,3.9-3.6,4c-0.1,0-0.3,0-0.4,0H3.9c-2.1,0.1-3.8-1.6-3.9-3.7C0,27.2,0,27.1,0,27z'
      />
      <path
        fill={fill[1]}
        d='M18.3,24c0-1-0.8-1.8-1.8-1.8S14.7,23,14.7,24c0,1,0.8,1.8,1.8,1.8S18.3,25.1,18.3,24z M17.7,18.4l0.3-8.1
		c-0.1-0.9-0.9-1.5-1.8-1.4C15.6,9,15,9.6,14.9,10.3l0.3,8.1c-0.1,0.7,0.4,1.3,1.1,1.4c0.1,0,0.1,0,0.2,0c0.7,0,1.2-0.6,1.2-1.3
		C17.7,18.5,17.7,18.5,17.7,18.4z'
      />
    </g>
  </svg>
)

export default SVG
